export const DIVISION_OPTIONS = [
  { label: "PKB", value: "PKB" },
  { label: "BO", value: "BO" },
  { label: "CB", value: "CB" },
  { label: "PA", value: "PA" },
];
